import { render, staticRenderFns } from "./CheckDocumentDetail.vue?vue&type=template&id=df66f152&"
import script from "./CheckDocumentDetail.vue?vue&type=script&lang=js&"
export * from "./CheckDocumentDetail.vue?vue&type=script&lang=js&"
import style0 from "./CheckDocumentDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports